import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e38b2536")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_form = _resolveComponent("a-form")
  const _component_my_modal = _resolveComponent("my-modal")

  return (_openBlock(), _createBlock(_component_my_modal, {
    visible: _ctx.basicVisible,
    loading: _ctx.basicLoading,
    onOnCancel: _ctx.onCancel,
    onOnOk: _ctx.onOk,
    okText: _ctx.okText,
    cancelText: _ctx.cancelText
  }, {
    content: _withId(() => [
      _createVNode(_component_a_form, {
        class: "form",
        model: _ctx.form,
        "label-col": { span: 4 },
        "wrapper-col": { span: 16 }
      }, {
        default: _withId(() => [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _: 3
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "loading", "onOnCancel", "onOnOk", "okText", "cancelText"]))
})